var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuSkrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "980px",
    height: "680px",
    viewBox: "0 0 980 680",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EU Skrill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    rx: 80
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.7%",
    y: "-10.0%",
    width: "113.3%",
    height: "120.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0176452694%",
    y1: "49.9676811%",
    x2: "100.005579%",
    y2: "49.9676811%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#872166",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F2455",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EU-Skrill",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(50, 163)",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636.161581,26.812489 L702.769448,14.9585465 L702.769448,270.523902 L636.161581,270.523902 L636.161581,26.812489 Z M733.392133,26.812489 L733.392133,270.382784 L800,270.382784 L800,14.9585465 L733.392133,26.812489 Z M541.471159,270.382784 L608.079026,270.382784 L608.079026,83.5420709 L541.471159,83.5420709 L541.471159,270.382784 Z M101.322985,109.931205 C92.8558829,109.366731 73.3815488,108.096666 73.3815488,90.5979891 C73.3815488,69.4302346 101.464103,69.4302346 111.906862,69.4302346 C130.393367,69.4302346 154.383489,74.9338508 171.458811,80.0141118 C171.458811,80.0141118 181.05486,83.4009525 189.098606,86.7877933 L189.804198,86.9289116 L189.804198,29.0703828 L188.81637,28.7881461 C168.636444,21.7322279 145.210796,14.9585465 101.605221,14.9585465 C26.5302522,14.9585465 0,58.705239 0,96.1016052 C0,117.692715 9.31381196,168.495325 95.254895,174.422297 C102.59305,174.845652 121.926266,175.974599 121.926266,194.178868 C121.926266,209.137414 106.121009,218.027871 79.4496384,218.027871 C50.2381372,218.027871 22.0144646,210.548598 4.79802434,203.492679 L4.79802434,263.185747 C30.4815664,269.959428 59.5519492,273.346269 93.5614747,273.346269 C166.943023,273.346269 199.823602,231.998589 199.823602,190.933145 C199.823602,144.364085 163.132828,114.164756 101.322985,109.931205 L101.322985,109.931205 Z M503.933674,80.860822 C442.406068,82.8364791 411.21891,110.495678 411.21891,165.390721 L411.21891,270.523902 L478.391251,270.523902 L478.391251,184.723937 C478.391251,151.843359 482.624802,137.731522 521.714588,136.461457 L521.714588,81.7075322 C514.940907,80.4374669 503.933674,80.860822 503.933674,80.860822 Z M323.30217,83.4009525 C321.890986,87.07003 311.16599,117.26936 285.34133,148.456518 L285.34133,14.9585465 L216.616687,28.5059093 L216.616687,270.382784 L285.34133,270.382784 L285.34133,195.590051 C305.239019,225.507144 315.117305,270.382784 315.117305,270.382784 L397.38931,270.382784 C389.204445,236.514376 353.642618,174.14006 353.642618,174.14006 C385.535368,133.63909 399.647204,90.4568707 401.905098,83.2598342 L323.30217,83.2598342 L323.30217,83.4009525 Z M574.633974,65.6200388 C592.697125,65.6200388 607.514553,50.9437291 607.514553,32.8805786 C607.514553,14.8174281 592.838243,-8.02165022e-14 574.633974,-8.02165022e-14 C556.570824,-8.02165022e-14 541.894514,14.6763098 541.894514,32.8805786 C541.894514,50.9437291 556.570824,65.6200388 574.633974,65.6200388 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuSkrill);
export default __webpack_public_path__ + "static/media/EU Skrill.1b406a26c0ecf7b09ff1163e5208f792.svg";
export { ForwardRef as ReactComponent };